// extracted by mini-css-extract-plugin
export default {"licenseLogo":"LicenseLogo_licenseLogo__kDLII"};